<div [formGroup]="parentForm">
    <div formGroupName="playerSettings">
        <mat-tab-group [dynamicHeight]="false">
            <mat-tab [label]="'functions' | transloco">
                <div class="player-setting">
                    <div>
                        <mat-checkbox formControlName="selfJudgementPopup"> {{ "self_assessment" | transloco }}
                        </mat-checkbox>
                    </div>
                    <div class="player-description">
                        {{ "self_assessment_desc" | transloco }}
                    </div>
                </div>
                <div class="player-setting">
                    <div>
                        <mat-checkbox formControlName="dontKnowBtn"> {{ "dont_know_btn" | transloco }} </mat-checkbox>
                    </div>
                    <div class="player-description">{{ "dont_know_btn_desc" | transloco }}</div>
                </div>
                <div class="player-setting">
                    <div>
                        <mat-checkbox formControlName="readoutExerciseText"> {{ "readout_exercise_text" | transloco }}
                        </mat-checkbox>
                    </div>
                    <div class="player-description">
                        {{ "readout_exercise_text_desc" | transloco }}
                    </div>
                </div>
                <div class="player-setting">
                    <div>
                        <mat-checkbox formControlName="randomOrderOfTestSequences">
                            {{ "random_order_test_sequences" | transloco }}
                        </mat-checkbox>
                    </div>
                    <div class="player-description">
                        {{ "random_order_test_sequences_desc" | transloco }}
                    </div>
                </div>
                <div class="player-setting">
                    <div>
                        <mat-checkbox formControlName="textSelectionEnabled">{{ "text_selection" | transloco
                            }}</mat-checkbox>
                    </div>
                    <div class="player-description">
                        {{ "text_selection_desc" | transloco }}
                    </div>
                </div>
                <div class="player-setting">
                    <div>
                        <mat-checkbox formControlName="emptyAnswerWarningPopup"> {{ "empty_answer_warning" | transloco
                            }}
                        </mat-checkbox>
                    </div>
                    <div class="player-description">{{ "empty_answer_warning_desc" | transloco }}</div>
                </div>
                <div class="player-setting">
                    <div>
                        <mat-checkbox formControlName="checkAnswerPopup"> {{ "check_answer_prompt" | transloco }}
                        </mat-checkbox>
                    </div>
                    <div class="player-description">
                        {{ "check_answer_prompt_desc" | transloco }}
                    </div>
                </div>
                <div class="player-setting">
                    <div>
                        <mat-checkbox formControlName="showNoteButton"> {{ "note_function" | transloco }}
                        </mat-checkbox>
                    </div>
                    <div class="player-description">
                        {{ "note_function_desc" | transloco }}
                    </div>
                </div>
                <div class="player-setting">
                    <div>
                        <mat-checkbox formControlName="showBottomPart"> {{ "lower_task_part" | transloco
                            }}</mat-checkbox>
                    </div>
                    <div class="player-description">
                        {{ "lower_task_part_desc" | transloco }}
                    </div>
                </div>
                <div class="player-setting">
                    <div>
                        <mat-checkbox formControlName="showExerciseSequenceTabs"> {{ "tabs_task_navigation" | transloco
                            }}
                        </mat-checkbox>
                    </div>
                    <div class="player-description">{{ "tabs_task_navigation_desc" | transloco }}
                    </div>
                </div>
                <div class="player-setting">
                    <div>
                        <mat-checkbox formControlName="showSelfRating"> {{ "self_rating" | transloco }} </mat-checkbox>
                    </div>
                    <div class="player-description">
                        {{ "self_rating_desc" | transloco }}
                    </div>
                </div>
                <div class="player-setting">
                    <div>
                        <mat-checkbox formControlName="hideResetExerciseButton"> {{ "hide_reset_button" | transloco }}
                        </mat-checkbox>
                    </div>
                    <div class="player-description">{{ "hide_reset_button_desc" | transloco }}</div>
                </div>
                <div class="player-setting">
                    <div>
                        <mat-checkbox formControlName="showCompletionIcons"> {{ "show_completion_progress" | transloco
                            }}
                        </mat-checkbox>
                    </div>
                    <div class="player-description">
                        {{ "show_completion_progress_desc" | transloco }}
                    </div>
                </div>
                <div class="player-setting">
                    <div>
                        <mat-checkbox formControlName="tabLetters"> {{ "label_tabs_alphabetically" | transloco }}
                        </mat-checkbox>
                    </div>
                    <div class="player-description">{{ "label_tabs_alphabetically_desc" | transloco }}
                    </div>
                </div>
                <div class="player-setting">
                    <div>
                        <mat-checkbox formControlName="flattenExercises">
                            {{ "split_exercises_to_tabs" | transloco }}
                        </mat-checkbox>
                    </div>
                    <div class="player-description">
                        {{ "split_exercises_to_tabs_desc" | transloco }}
                    </div>
                </div>
                <div class="player-setting">
                    <div class="player-setting-combo">
                        <mat-form-field>
                            <mat-label>{{ "number_of_tries" | transloco }}</mat-label>
                            <mat-select formControlName="maxTries">
                                <mat-option value="1">1</mat-option>
                                <mat-option value="2">2</mat-option>
                                <mat-option value="3">3</mat-option>
                                <mat-option value="4">4</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="player-description">
                        {{ "number_of_tries_desc" | transloco }}
                    </div>
                </div>
                <div class="player-setting">
                    <div class="player-setting-combo">
                        <mat-form-field>
                            <mat-label>{{ "try_again" | transloco }}</mat-label>
                            <mat-select formControlName="retryMode">
                                <mat-option value="keepCorrectAnswers">{{ "keep_correct_answers" | transloco
                                    }}</mat-option>
                                <mat-option value="freezeCorrectAnswers">{{ "freeze_correct_answers" | transloco
                                    }}</mat-option>
                                <mat-option value="clearAllAnswers">{{ "clear_all_answers" | transloco }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="player-description">
                        {{ "try_again_desc" | transloco }}<br />
                        <b>{{ "keep_correct_answers" | transloco }}</b>: {{ "keep_correct_answers_desc" | transloco
                        }}<br />
                        <b>{{ "freeze_correct_answers" | transloco }}</b>: {{ "freeze_correct_answers_desc" | transloco
                        }}
                    </div>
                </div>
                <div class="player-setting">
                    <div class="player-setting-combo">
                        <mat-form-field>
                            <mat-label>{{ "footer_info" | transloco }}</mat-label>
                            <mat-select formControlName="footerInfo">
                                <mat-option value="none">{{ "no_display" | transloco }}</mat-option>
                                <mat-option value="id">{{ "task_id" | transloco }}</mat-option>
                                <mat-option value="name">{{ "task_name" | transloco }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="player-description">
                        {{ "footer_info_desc" | transloco }}<br />
                        <b>{{ "task_id" | transloco }}</b>: {{ "task_id_desc" | transloco }}<br />
                        <b>{{ "task_name" | transloco }}</b>: {{ "task_name_desc" | transloco }}
                    </div>
                </div>
            </mat-tab>

            <mat-tab [label]="'color_scheme' | transloco">
                <br />
                <div
                    class="player-colors-container"
                    formGroupName="theme"
                >

                    <div class="player-colors-item">{{ "primary_color" | transloco }}</div>
                    <button
                        type="button"
                        class="color-circle-preview"
                        [attr.aria-label]="'primary_color' | transloco"
                        [style.background-color]="getColorValue('primaryColor')"
                        (click)="openColorPicker('primaryColor', 'primary_color')"
                    ></button>

                    <div class="player-colors-preview">
                        @if (!consumerId) {
                        {{ "preview_not_available_new_consumer" | transloco }}
                        <br /><br />
                        {{ "save_consumer_first" | transloco }}
                        } @else {
                        <div class="btn-iframe">
                            <button
                                mat-button
                                (click)="setDefaultTheme()"
                                [disabled]="disabledColorSchemeBtn()"
                                [matTooltip]="'reset_color_scheme_tooltip' | transloco"
                            >
                                {{ "reset_color_scheme" | transloco }}
                            </button>
                        </div>
                        <iframe
                            #playerPreviewIframe
                            class="consumerPlayerSettingsPreview"
                            [src]="iframePreviewUrl!"
                            (load)="onIframeLoaded()"
                        ></iframe>
                        }
                    </div>

                    <div class="player-colors-item">{{ "secondary_color" | transloco }}</div>
                    <button
                        type="button"
                        class="color-circle-preview"
                        [attr.aria-label]="'secondary_color' | transloco"
                        [style.background-color]="getColorValue('secondaryColor')"
                        (click)="openColorPicker('secondaryColor', 'secondary_color')"
                    ></button>

                    <div class="player-colors-item">{{ "tertiary_color" | transloco }}</div>
                    <button
                        type="button"
                        class="color-circle-preview"
                        [attr.aria-label]="'tertiary_color' | transloco"
                        [style.background-color]="getColorValue('tertiaryColor')"
                        (click)="openColorPicker('tertiaryColor', 'tertiary_color')"
                    ></button>

                    <div class="player-colors-item">{{ "placeholder_color" | transloco }}</div>
                    <button
                        type="button"
                        class="color-circle-preview"
                        [attr.aria-label]="'placeholder_color' | transloco"
                        [style.background-color]="getColorValue('placeholderColor')"
                        (click)="openColorPicker('placeholderColor', 'placeholder_color')"
                    ></button>

                    <div class="player-colors-item">{{ "mouseover_color" | transloco }}</div>
                    <button
                        type="button"
                        class="color-circle-preview"
                        [attr.aria-label]="'mouseover_color' | transloco"
                        [style.background-color]="getColorValue('hoverColor')"
                        (click)="openColorPicker('hoverColor', 'mouseover_color')"
                    ></button>

                    <div class="player-colors-item">{{ "drawing_pen_color" | transloco }}</div>
                    <button
                        type="button"
                        class="color-circle-preview"
                        [attr.aria-label]="'drawing_pen_color' | transloco"
                        [style.background-color]="getColorValue('drawColor')"
                        (click)="openColorPicker('drawColor', 'drawing_pen_color')"
                    ></button>

                    <div class="player-colors-item">{{ "drawing_selection_color" | transloco }}</div>
                    <button
                        type="button"
                        class="color-circle-preview"
                        [attr.aria-label]="'drawing_selection_color' | transloco"
                        [style.background-color]="getColorValue('drawHighlightColor')"
                        (click)="openColorPicker('drawHighlightColor', 'drawing_selection_color')"
                    ></button>

                    <div class="player-colors-item">{{ "solution_comparison_bg_color" | transloco }}</div>
                    <button
                        type="button"
                        class="color-circle-preview"
                        [attr.aria-label]="'solution_comparison_bg_color' | transloco"
                        [style.background-color]="getColorValue('compareSolutionsBgColor')"
                        (click)="openColorPicker('compareSolutionsBgColor', 'solution_comparison_bg_color')"
                    ></button>
                </div>
            </mat-tab>

            <mat-tab [label]="'font' | transloco">
                <div class="player-fonts-section">
                    @for (group of groupedCompetencies; track group.letter) {
                    <div class="player-letter-group">
                        <h3>{{ group.letter }}</h3>
                        <div class="player-fonts-container">
                            @for (competency of group.competencies; track competency.treeId) {
                            <div class="player-font-item">
                                <mat-form-field>
                                    <mat-label>{{ competency.name }}</mat-label>
                                    <mat-select
                                        [value]="getFont(competency)"
                                        (valueChange)="setFont($event, competency)"
                                    >
                                        @for (font of availableFonts; track font.id) {
                                        <mat-option [value]="font.id">{{ font.name }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            }
                        </div>
                    </div>
                    }
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>